import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostUtilUpload = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const changeEvent = (e) => {
        const image = e.target.files[0]

        if (image) {
            const formdata = new FormData()
            formdata.append("src", image)
            fetchRequest("POST", "/util/upload", null, formdata)
        }
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "src") setAlert("이미지의 확장자와 용량을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult?.data?.path, changeEvent]
}

export default usePostUtilUpload